import { Button } from '@mui/material'
import React, { useContext, useState } from 'react'
import { FaCheckCircle, FaMinus, FaPlus } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import CustomSwitch from '../../../component/CustomSwitch'
import { useSelector } from 'react-redux'
import { CoachAPI } from '../../../api/CoachAPI'
import { AuthContext } from '../../auth/AuthContext'
import { SubscriptionAPI } from '../../../api/SubscriptionAPI'

const PlanCard = ({ planInfo, finishLoading, startLoading,onToggle, isYear }) => {
    const { getCurrentUser } = useContext(AuthContext);
    const navigate = useNavigate();
    const configId = useSelector((store) => store.stepper.configId);
    const userId = useSelector((state) => state.user.userInfo.userId);
    const selectedClub = useSelector((state) => state.user.selectedClub);
    const [totalCourt, setTotalCourt] = useState(1);

    const increaseCourtNo = () => {
        setTotalCourt(totalCourt + 1);
    };
    const decreaseCourtNo = () => {
        if (totalCourt <= 1) {
            return;
        }
        setTotalCourt(totalCourt - 1);
    };

    const handleUpdateFreePlan = async () => {
        const subInfo = {
            userId: userId,
            clubId: selectedClub?.clubId,
            planId: planInfo.planId
        }
        try {
            startLoading("loading7")
            await SubscriptionAPI.postPurchaseFreeCoachPlan(subInfo);
            await CoachAPI.updateAccountSetupPlanInfo({
                accountSetupConfigId: configId,
                freePlan: true
            });

            getCurrentUser();
        } catch (error) {

        }finally{
            finishLoading("loading7")
        }
    }

    const createPaymentClientSecret = async () => {
            try {
                const planInfoObject = {
                    priceId: isYear ? planInfo?.yearlyPriceId : planInfo?.monthlyPriceId,
                    userId: userId,
                    clubId: selectedClub?.clubId,
                    subQuantity: totalCourt,
                    planId: planInfo?.planId,
                    isSubForPlatform: true,
                    planFor: planInfo?.planFor,
                }
                startLoading("loading7")
                const subscriptionResponse = await SubscriptionAPI.postPurchasePlan(planInfoObject);
                if (subscriptionResponse?.Data?.subscriptionId) {
                    navigate('/subscription-platform', {
                        replace: true,
                        state: {
                            subscriptionId: subscriptionResponse.Data.subscriptionId,
                            clientSecretKey: subscriptionResponse.Data.clientSecretKey
                        }
                    })
                }
            } catch (error) {
                console.error('error', error)
            }finally{
                finishLoading("loading7")
            }
        }


    return (
        <>
            <div className="manage_sub_price_details">
                {!isYear ?
                    <div className="court_price_container">
                        <h3 className="court_price_details_heading">{planInfo.productName}</h3>
                        <h3>Monthly Pricing</h3>
                        <p style={{ textAlign: 'center' }}>For small teams who want to gain free access to our fan-favorite features.</p>
                        {planInfo?.planFor === "CLUB_RESERVATION" ?
                            <p className="court_price_per_court">
                                ${planInfo?.monthlyUnitAmount ? planInfo?.monthlyUnitAmount / 100 : 0} <span>per court</span>
                            </p>
                            :
                            <p className="court_price_per_court">
                                ${planInfo?.monthlyUnitAmount ? planInfo?.monthlyUnitAmount / 100 : 0} <span>per month</span>
                            </p>
                        }
                        {planInfo?.yearlyUnitAmount ?
                            <>
                                <br />
                                <CustomSwitch checked={isYear} onChange={(args) => onToggle(args.target.checked)} />
                            </>
                            :
                            <div style={{ height: '50px' }}>

                            </div>
                        }
                        <hr />
                        {planInfo?.planFor === "CLUB_RESERVATION" ?
                            <div className="select_court_no_body">
                                <p>Total court</p>
                                <div className="select_court_no_input">
                                    <button onClick={decreaseCourtNo}>
                                        <FaMinus className="select_court_no_input_icon" />
                                    </button>
                                    <span id="total_court_no">{totalCourt}</span>
                                    <button onClick={increaseCourtNo}>
                                        <FaPlus className="select_court_no_input_icon" />
                                    </button>
                                </div>
                            </div>
                            :
                        <div style={{ height: '60px' }}>

                        </div>
                            }
                        <div className="plan_features">
                            {Object.values(planInfo?.features).filter(data=>data!=null).map((val, index) =>
                                <p key={index}>
                                    <FaCheckCircle className="plan_features_icon" />{val}
                                </p>
                            )}

                        </div>
                        <div className="court_plan_purchase_btn">
                            <Button
                                onClick={() => {
                                    if (planInfo.productName === 'Free') {
                                        handleUpdateFreePlan();
                                    } else {
                                        createPaymentClientSecret();
                                    }
                                }
                                }
                                fullWidth
                                variant="contained"
                            >
                                {planInfo.productName === 'Free' ? 'try free' : '30 days free trial'}
                            </Button>
                        </div>
                        <svg
                            className="admin-sub-details-dollar-sign"
                            width="40"
                            height="40"
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                    </div>
                    :
                    <div className="court_year_price_container">
                        <h3 className="court_year_price_details_heading">{planInfo?.productName}</h3>
                        <h3>Yearly Pricing</h3>
                        <p style={{ textAlign: 'center' }}>For teams wanting to also track stats and create shareable lineups.</p>
                        {planInfo?.planFor === "CLUB_RESERVATION" ?
                            <p className="court_year_price_per_court">
                                ${planInfo?.yearlyUnitAmount ? planInfo?.yearlyUnitAmount / 100 : 0} <span>per court</span>
                            </p>
                            :
                            <p className="court_year_price_per_court">
                                ${planInfo?.yearlyUnitAmount ? planInfo?.yearlyUnitAmount / 100 : 0} <span>per year</span>
                            </p>}
                        <br />
                        <CustomSwitch checked={isYear} onChange={(args) => onToggle(args.target.checked)} />
                        <hr />
                        {planInfo?.planFor === "CLUB_RESERVATION" ?
                            <div className="select_court_no_body">
                                <p>Total court</p>
                                <div className="select_court_no_input">
                                    <button onClick={decreaseCourtNo}>
                                        <FaMinus className="select_court_no_input_icon" />
                                    </button>
                                    <span id="total_court_no">{totalCourt}</span>
                                    <button onClick={increaseCourtNo}>
                                        <FaPlus className="select_court_no_input_icon" />
                                    </button>
                                </div>
                            </div>
                            :
                            <div style={{height:'40px'}}>

                            </div>
                            }
                        <div className="plan_features">
                            {Object.values(planInfo?.features).filter(data => data != null).map((val, index) =>
                                <p key={index}>
                                    <FaCheckCircle className="plan_features_icon" />{val}
                                </p>
                            )}
                        </div>
                        <div className="court_year_plan_purchase_btn">
                            <Button
                                onClick={() => {
                                    if (planInfo.productName === 'Free') {
                                       
                                    } else {
                                        createPaymentClientSecret();
                                    }
                                }
                                }
                                fullWidth
                                variant="contained"
                            >
                                {planInfo.productName === 'Free' ? 'try free' : '30 days free trial'}
                            </Button>
                        </div>
                        <svg
                            className="admin-sub-details-dollar-sign"
                            width="40"
                            height="40"
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                    </div>
                }
            </div>
        </>
    )
}

export default PlanCard